module.exports = __webpack_public_path__ + "static/background-image-modal-movil-022cf97071f2fe2ed1477145c2457d6f.png";